import {createRouter, createWebHistory} from 'vue-router';
import HomeKr from '@/components/HomeKr.vue';
import PreRegistration from '@/components/PreRegistration.vue';
import PreRegRewardClaim from '@/components/PreRegRewardClaim.vue';
import {preLoadWallpapers} from "@/assets/util/image";

const routes = [
    {
        path: '/',
        component: HomeKr,
        meta: {title: '취준생 키우기'},
        beforeEnter: () => {
            preLoadWallpapers();
        }
    },
    {
        path: '/preregistration',
        component: PreRegistration,
        meta: {title: '사전예약 | 취준생 키우기'},
    },
    {
        path: '/preregistration-reward',
        component: PreRegRewardClaim,
        meta: {title: '사전예약 보상 받기 | 취준생 키우기'},
    },
    {
        path: '/:pathMatch(.*)*', // 잘못된 경로는 홈으로 리다이렉트
        redirect: '/'
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to) => {
    document.title = to.meta.title || 'Job Maker';
});

export default router;
